import React from 'react';
import { useParams } from 'react-router-dom';
import EnergyBreadCrumb from './EnergyBreadCrumb';
import RenewEnergyTabs from './RenewEnergyTabs';

function RenewEnergy() {
  const { plantName, id } = useParams();

  return (
    <>
      <EnergyBreadCrumb plantName={decodeURIComponent(plantName)} />
      <RenewEnergyTabs plantId={id} />
      {/* <AdvertiseBanner /> */}
    </>
  );
}

export default RenewEnergy;
